export default __webpack_public_path__ + "static/media/l3sgiphy.42b076df.gif";